/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BulkEditRequestBulkEditCorrectInner
 */
export interface BulkEditRequestBulkEditCorrectInner {
    /**
     * 
     * @type {string}
     * @memberof BulkEditRequestBulkEditCorrectInner
     */
    op: BulkEditRequestBulkEditCorrectInnerOpEnum;
    /**
     * One of: recordingTitle, duration, live, recordingVersion
     * @type {string}
     * @memberof BulkEditRequestBulkEditCorrectInner
     */
    field: string;
    /**
     * str | list[str] | bool per contract
     * @type {object}
     * @memberof BulkEditRequestBulkEditCorrectInner
     */
    value: object;
}


/**
 * @export
 */
export const BulkEditRequestBulkEditCorrectInnerOpEnum = {
    Edit: 'edit',
    Add: 'add',
    Delete: 'delete'
} as const;
export type BulkEditRequestBulkEditCorrectInnerOpEnum = typeof BulkEditRequestBulkEditCorrectInnerOpEnum[keyof typeof BulkEditRequestBulkEditCorrectInnerOpEnum];


/**
 * Check if a given object implements the BulkEditRequestBulkEditCorrectInner interface.
 */
export function instanceOfBulkEditRequestBulkEditCorrectInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "op" in value;
    isInstance = isInstance && "field" in value;
    isInstance = isInstance && "value" in value;

    return isInstance;
}

export function BulkEditRequestBulkEditCorrectInnerFromJSON(json: any): BulkEditRequestBulkEditCorrectInner {
    return BulkEditRequestBulkEditCorrectInnerFromJSONTyped(json, false);
}

export function BulkEditRequestBulkEditCorrectInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkEditRequestBulkEditCorrectInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'op': json['op'],
        'field': json['field'],
        'value': json['value'],
    };
}

export function BulkEditRequestBulkEditCorrectInnerToJSON(value?: BulkEditRequestBulkEditCorrectInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'op': value.op,
        'field': value.field,
        'value': value.value,
    };
}

